import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, Box } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

interface SuccessPopupProps {
    message: any;
    onClose: () => void;
    open: boolean;
}

const SuccessPopup: React.FC<SuccessPopupProps> = ({ message, onClose, open }) => {
    return (
        <Dialog open={open} onClose={onClose}
            sx={{
                '& .MuiPaper-root': {
                    borderRadius: '12px',
                },
            }}


        >

            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', margin: '20px', borderBottom: '1px dashed #D3D3D3', pb: 2 }}>
                <Box sx={{ display: 'flex', gap: '15px', alignItems: 'center' }}>
                    <CheckCircleIcon style={{ color: '#34C77D', fontSize: '40px' }} />
                    <DialogTitle sx={{ color: '#000', display: 'inline-block', p: 0 }}>Successfully Created</DialogTitle>
                </Box>

                {/* <Box>
                    <Button variant="text">View details</Button>

                </Box> */}
            </Box>

            <DialogContent sx={{ pt: 0 }}>
                <DialogContentText sx={{ color: '#000' }}>{message}</DialogContentText>
            </DialogContent>

        </Dialog>
    );
};

export default SuccessPopup;